import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import './index/hotelCssImport';
import '@/css/desktop/tooltip.scss';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import hotelPageGAEventsView from '@/js/desktop/components/hotelPageGAEvents/hotelPageGAEvents';
import PriceWarrantyBlockView from '@/js/common/components/priceWarrantyBlock';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import trackImageErrors from '@/js/common/Domain/Service/trackImageErrors';
import getHotelVideoById from '@ve/services/entities-services/hotel/getHotelVideoById';
import HotelPageReviewsView from './index/reviews/HotelPageReviews';
import HotelPageView from './index/HotelPageDistributed';
import initHotelPageGallery from './index/initHotelPageGallery';

const Controller = Backbone.View.extend({
    view: null,
    initModels() {
        this.dataLayerAnalytics = new DataLayerAnalytics({
            step: 'hotelPage',
            maxStep: 2,
        });

        this.view = new HotelPageView({
            el: 'body',
            hotelInfo: window.appConfig.hotelInfo,
            dataLayerAnalytics: this.dataLayerAnalytics,
        });

        initHotelPageGallery({
            el: '.gallery-wrapper__images',
            images: window.appConfig?.hotelPhotos || null,
            videos: window.appConfig?.hotelVideos || null,
            video: getHotelVideoById(window?.appConfig?.hotelInfo?.id),
        });

        new HotelPageReviewsView({
            el: '#reviewsTabs',
        });

        hotelPageGAEventsView.init();
        new PriceWarrantyBlockView({
            el: '#hotTourTicket',
        });
    },
    initCarousel() {
        const $carousel = $('.similar-hotel__carousel');
        $carousel.jsCarousel();

        /* init errors tracking */
        trackImageErrors($carousel.find('img').map((index, img) => $(img).attr('src')));
    },
    initialize() {
        this.initModels();
        this.initCarousel();

        trackingService.trackHotelView({
            hotelId: window.appConfig.hotelInfo.id,
        });
    },
});

$(() => {
    new Controller({
        el: 'body',
    });
});
